export class TabModel {
    title: string;
    component: any;
    active: boolean = false;
    autoSelection: boolean = false;
    data: any;
}


// WEBPACK FOOTER //
// ./node_modules/@rx/view/tab/tab.models.ts